import { addDoc, collection, deleteDoc, doc, onSnapshot, query, setDoc, orderBy } from 'firebase/firestore';
import { db } from '../../plugins/firebase';
const collectionName = "place";
export default {
    namespaced: true,
    state: {
        data: []
    },
    actions: {
        async load(context, {refresh=true}) {
            //console.log(`refresh:${refresh}`)
            if(context.state.data.length == 0 || refresh) {
                //const db = getDatabase();
                var q = query(collection(db, collectionName));
                q = query(q, orderBy('id'));
                onSnapshot(q, (snapshot) => {
                    const data = [];
                    snapshot.forEach((doc) => {
                        const docData = doc.data();
                        docData.__id = doc.id;
                        docData.show = true;
                        //console.log(docData)
                        data.push(docData);
                    })
                    context.commit('setData', data);
                });
            }
        },
        initPlace: {
            root:true,
            handler: async (context) => {await context.dispatch('load', {refresh:false})},
        },
        async update(context, item) {
            //const db = getDatabase();
            const docData = Object.assign({}, item);
            delete docData.__id;

            // データの整形
            docData.id = parseInt(docData.id);
            docData.order = parseInt(docData.order);

            if(!item.__id) {
                await addDoc(collection(db, collectionName), docData);
            }
            else {
                const ref = await doc(collection(db, collectionName), item.__id);
                await setDoc(ref, docData);
            }
        },
        async delete(context, item) {
            //const db = getDatabase();
            if(item.__id) {
                const ref = await doc(collection(db, collectionName), item.__id);
                await deleteDoc(ref);
            }
        }
    },
    mutations: {
        setData(state, data) {
            state.data = data;
        }
    }
}